import type { TFunction } from 'i18next';

import type {
  NotificationDisplayDomain,
  NotificationPreferenceGroup,
  NotificationTemplateCategory,
} from '../types/interfaces/notification-admin';

export function notificationCategoryLabel(
  t: TFunction,
  c: NotificationTemplateCategory,
): string {
  return t(`adminDashboard.notifications.enums.category.${c}`);
}

export function notificationPreferenceGroupLabel(
  t: TFunction,
  p: NotificationPreferenceGroup,
): string {
  return t(`adminDashboard.notifications.enums.preferenceGroup.${p}`);
}

export function notificationDisplayDomainLabel(
  t: TFunction,
  d: NotificationDisplayDomain,
): string {
  return t(`adminDashboard.notifications.enums.displayDomain.${d}`);
}
